var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reqsType',{attrs:{"baseUrlpath":_vm.baseUrlpath,"reqType":_vm.reqType}})
}
var staticRenderFns = []

export { render, staticRenderFns }